import { createSelector } from '@reduxjs/toolkit';
import { entitiesSelector } from "./base";
import { conditionTypesSelector } from "../types";
export const conditionsSelector = createSelector(entitiesSelector, conditionTypesSelector, ({
  conditions
}, conditionTypes) => {
  // TODO: I don't like this, but until we add original_type_id to
  // the conditions serializer this is necessary since we need the
  // original_type_id to have the lookup method work.
  const enhancedConditions = conditions.map(condition => {
    const conditionType = conditionTypes.find(({
      id
    }) => {
      return condition.condition_type_id === id;
    }) || {};
    return {
      ...condition,
      original_type_id: conditionType.original_type_id
    };
  });
  return enhancedConditions;
});